export * from "./PrizeLocatorMap";
